import React from "react";

import styles from "../../assets/css/components/Input/Input.module.css";
import Select from "react-select";
import SimpleValue from "../SelectSimpleValue";
import classnames from "classnames";

const customStyles = {
  option: (styles, { isDisabled, isSelected }) => {
    return {
      ...styles,
      backgroundColor: "#17171d",

      color: isSelected ? "#00dd80" : "#848486",

      cursor: isDisabled ? "not-allowed" : "pointer",

      ":active": {
        ...styles[":active"],
        color: isSelected ? "#0d0f11" : "#848486",
        backgroundColor: "#00dd80",
      },
    };
  },

  menuList: (styles) => ({
    ...styles,
    backgroundColor: "#0d0f11",
  }),

  indicatorSeparator: (styles) => ({ ...styles, display: "none" }),

  placeholder: (styles) => {
    return {
      ...styles,
      color: "#848486",
      fontSize: ".9rem",
    };
  },

  input: (styles) => {
    return {
      ...styles,
      color: "#00dd80",
    };
  },

  control: () => ({
    // none of react-select's styles are passed to <Control />
    width: "100%",
    height: "46px",
    display: "flex",
    flexdirection: "row",
  }),
  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = "opacity 300ms";
    const color = "#00dd80";

    return { ...provided, opacity, transition, color };
  },
};

function InputSelect({ error, title, value, options, defaultValue, ...props }) {
  return (
    <div className={styles.container}>
      <p className={styles.title}>{title}</p>
      <div className={classnames(styles.input, styles.contSelect)}>
        <SimpleValue options={options} value={value}>
          {(simpleProps) => (
            <Select
              {...props}
              {...simpleProps}
              placeholder="Seleccionar"
              styles={customStyles}
              defaultValue={defaultValue}
              noOptionsMessage={() => "No se encontraron opciones"}
            />
          )}
        </SimpleValue>
      </div>
      {error && <p className={styles.txtWarning}>{error}</p>}
    </div>
  );
}

export default InputSelect;
